import React__default from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardActionArea } from '@material-ui/core';

var useStyles = makeStyles(function (theme) {
  return {
    card: {
      boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2)",
      borderRadius: theme.spacing(1)
    },
    cardWrapper: {
      display: "flex",
      justifyContent: "center",
      padding: theme.spacing(3)
    }
  };
});
var CardButton = function CardButton(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    className = _ref.className;
  var classes = useStyles();
  var handleClick = function handleClick() {
    onClick();
  };
  return /*#__PURE__*/React__default.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React__default.createElement(CardActionArea, {
    className: className ? className : classes.cardWrapper,
    onClick: handleClick
  }, children));
};
CardButton.propTypes = {
  children: PropTypes__default.any,
  onClick: PropTypes__default.func,
  className: PropTypes__default.any
};

export { CardButton as default };
//# sourceMappingURL=CardButton.js.map
